import { Outlet, Route, Routes } from "react-router-dom";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useAuth } from "@/contexts/AuthContext";
import { RegisterForm } from "@/components/auth/RegisterForm";
import { NotImplementedYet } from "@/components/NotImplementedYet";
import { DirectoryMenu } from "./DirectoryMenu";
import { CommunityAdmin, CommunityAdminAdd, CommunityAdminEdit, CommunityList, CommunityMenu, CommunityNews } from "./CommunityMenu";
import { MainMenu } from "./MainMenu";
import { ViewPersonal } from "@/components/directories/ViewPersonal";
import { ViewAlumni } from "@/components/directories/ViewAlumni";
import { TestingMenu } from "./TestingMenu";
import AlumniProfileView from "@/test/AlumniProfileView";
import { SLA2026 } from "@/components/communities/sla/SLA2026";
import { SLA2026_Venue } from "@/components/communities/sla/SLA2026-venue";
import ChartConfirmation from "@/components/communities/ChartConfirmations";
import ShowQR from "@/components/communities/ShowQR";
import ScanQR from "@/components/communities/ScanQR";
import ChartPresention from "@/components/communities/ChartPresention";
import { Notify, useNotify } from "@/contexts/NotifyContext";
import { ProfilePhotoEditor } from "@/test/ProfilePhotEditor";
import { ViewDuplicate } from "@/components/directories/ViewDuplicate";
import { RegisterApproval } from "@/components/auth/RegisterForm/RegisterApproval";
import { ViewRoles } from "@/components/directories/ViewRoles";
import { ViewRolesEdit } from "@/components/directories/ViewRolesEdit";
import { AbsensiManual } from "@/components/communities/AbsensiManual";
import { DirectoryRoot } from "@/components/directories/DirectoryRoot";
import DemoPageResponsiveDataTable from "@/test/ResponsiveDataTable";
import { EVENT_ID_SLA2026 } from "iasma-datatypes";
import JsonCompareMergePage from "@/test/compare.chatgpt";
import JsonRecordCompare from "@/test/compare.claude";
import JsonCompareMergePage2 from "@/test/compare.chatgpt2";
import JsonRecordCompare2 from "@/test/compare.claude2";
import { Loading } from "@/components/Loading";
import { ViewMergeTest } from "@/components/directories/ViewMerge.test";


export const MainContent: React.FC = () => {
  const { isLoading, session } = useAuth();
  const { notify } = useNotify();

  if (isLoading) {
    return <Loading />;
  } else {
    if (session) {
      if (session.User) {
        if (session.User.Alumni) {
          return (
            <div>
              { notify && <Notify />}
              <Routes>
                <Route index element={<MainMenu />} />
                <Route path='sla' element={<SLA2026 />} />
                <Route path='sla/venue' element={<SLA2026_Venue />} />
                <Route path='sla/showqr' element={<ShowQR eventId={EVENT_ID_SLA2026}/>} />
                <Route path='sla/scanqr' element={<ScanQR eventId={EVENT_ID_SLA2026} />} />
                <Route path='sla/absensi' element={<AbsensiManual eventId={EVENT_ID_SLA2026} />} />
                {/* <Route path='sla/biodata' element={<ViewPersonal backpath="/sla"/>} /> */}
                <Route path='sla/chart-confirmation' element={<ChartConfirmation eventId={EVENT_ID_SLA2026}/>} />
                <Route path='sla/chart-presence' element={<ChartPresention eventId={EVENT_ID_SLA2026} />} />
                {/* <Route path='sla/test' element={<App />} /> */}


                <Route path='directory' element={<DirectoryMenu />}>
                  <Route index element={<DirectoryRoot />} />
                  <Route path='personal' element={<ViewPersonal />} />
                  <Route path='iasma/:graduation?' element={<ViewAlumni />} />
                  <Route path='statistic' element={<NotImplementedYet info="Statistik Report" />} />
                  <Route path='admin' element={<NotImplementedYet info="Administrasi Direktori" />} />
                  <Route path='approval' element={<RegisterApproval />} />
                  <Route path='duplicate' element={<ViewDuplicate />} />
                  <Route path='roles' element={<ViewRoles />} />
                  <Route path="roles/add" element={<ViewRolesEdit />} />
                  <Route path="roles/edit/:userId/:email/:grad" element={<ViewRolesEdit />} />
                  <Route path='test_photo' element={<ProfilePhotoEditor />} />
                  <Route path='test_table' element={<DemoPageResponsiveDataTable />} />
                </Route>
                <Route path='community' element={<CommunityMenu />}>
                  <Route index element={<CommunityList />} />
                  <Route path='list' element={<CommunityList />} />
                  <Route path='news' element={<CommunityNews />} />
                  <Route path='admin' element={<CommunityAdmin />} />
                  <Route path='admin/add' element={<CommunityAdminAdd />} />
                  <Route path='admin/edit/:id' element={<CommunityAdminEdit />} />
                </Route>

                <Route path='test' element={<TestingMenu />}>
                  <Route index element={<NotImplementedYet info="index" />} />
                  <Route path='profile' element={<AlumniProfileView />} />
                  <Route path='admin' element={<NotImplementedYet info="Administrasi Komunitas" />} />
                  <Route path='compare-chatgpt' element={<JsonCompareMergePage />} />
                  <Route path='compare-chatgpt-2' element={<JsonCompareMergePage2 />} />
                  <Route path='compare-claude' element={<JsonRecordCompare />} />
                  <Route path='compare-claude-2' element={<JsonRecordCompare2 />} />
                  <Route path='merge_test' element={<ViewMergeTest />} />
                </Route>
              </Routes>
              <div className="bg-(--color-surface) text-(--color-text)">
                <Outlet />
              </div>
            </div>)
        } else {
          return (
            <GoogleReCaptchaProvider
              reCaptchaKey="6LflnDIsAAAAAKCs0knhO1u1TIkaamUtGh57zU_v"
              scriptProps={{
                async: true,
                defer: true,
                appendTo: "head",
              }}
            >
              { notify && <Notify />}
              <RegisterForm />
            </GoogleReCaptchaProvider>
          );
        }
      } else {
        return <>no user</>
      }
    } else {
      return <>no session</>
    }
  }
};